import type { TemuProducttypeCategory } from '@/api/temuProducttypes/types'

export function filterTemuProducttypes(
  rows: readonly TemuProducttypeCategory[],
  search: string,
): readonly TemuProducttypeCategory[] {
  const normalizedSearch = search.trim().toLocaleLowerCase('de-DE')
  if (normalizedSearch === '') return rows

  return rows.filter((row) =>
    [row.producttypeName, row.producttypeKey, String(row.categoryId), row.categoryName ?? ''].some(
      (value) => value.toLocaleLowerCase('de-DE').includes(normalizedSearch),
    ),
  )
}
